// extracted by mini-css-extract-plugin
export default {"formHeading":"TH-z","form":"UH-z","submitBtn":"VH-z","disabled":"WH-z","input":"XH-z","error":"YH-z","submitMsg":"ZH-z","signIn":"_H-z"};